import { call, put } from 'redux-saga/effects'
import { getPositions } from '../apiModules/positions'
import { positionEntities } from '../reducks'

export function* fetchPositionEntitiesSaga(hiringTeamId, params) {
  const response = yield call(getPositions, hiringTeamId, params)

  if (response.result.length > 0) {
    yield put(positionEntities.addCollection(response.result))
  }

  return response
}
